module.exports = __webpack_public_path__ + "img/index-s-4.3ece20c4.png";